module.exports = __webpack_public_path__ + "img/maropost-icon.feb9fa43.svg";